import "./LyneFormField.scss";

import classNames from "classnames";
import { LeanLabel } from "components/Lean/LeanLabel";
import React, { PropsWithChildren } from "react";

export interface LyneFormFieldProps extends PropsWithChildren {
  name?: string;
  label: string;
  size?: "s" | "m" | "l";
  className?: string;
  required?: boolean;
  hasFocus?: boolean;
  contextHelp?: string;
}

export const LyneFormField: React.FC<LyneFormFieldProps> = ({
  name,
  label,
  children,
  className,
  required,
  hasFocus,
}) => {
  className = classNames("lyne-form-field", className, hasFocus ? "has-focus" : "");

  return (
    <div className={className}>
      <LeanLabel name={name} title={label} required={required} />
      {children}
    </div>
  );
};
